<template>
  <div class="p-4 sm:p-6 lg:p-10 max-w-7xl mx-auto">
    <PageHeader title="Twoje dane" subtitle="Tutaj uaktualnisz dane potrzebne do kontaktu i rozliczeń" />

    <form @submit.prevent="handleSubmit" class="space-y-4">
      <!-- Dane Rozliczeniowe + Adres w jednym boxie -->
      <FormSection title="Dane Rozliczeniowe" class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">

        <FormInput class="sm:col-span-3" v-model="formData.first_name" label="Imię" placeholder="Wpisz..." />
        <FormInput class="sm:col-span-3" v-model="formData.last_name" label="Nazwisko" placeholder="Wpisz..." />

        <!-- Adres section inside the same box -->
        <h3 class="sm:col-span-6 text-base font-bold text-neutral-850">Adres</h3>


        <FormInput class="sm:col-span-6" v-model="formData.address" label="Ulica i numer domu" placeholder="Wpisz..." />

        <FormInput class="sm:col-span-3" v-model="formData.city" label="Miasto" placeholder="Wroclaw" />
        <FormInput class="sm:col-span-3" v-model="formData.postalcode" label="Kod pocztowy" placeholder="30-444" />


        <div class="sm:col-span-6 flex items-start gap-3 p-4 -mx-4 rounded-lg">
          <div class="mt-0.5">
            <ToggleSwitch v-model="formData.needs_company" />
          </div>
          <label class="flex-1 cursor-pointer" @click="formData.needs_company = !formData.needs_company">
            <div class="text-sm font-semibold text-neutral-850 block mb-1">Faktura dla firmy</div>
            <div class="text-xs text-neutral-600">Zaznacz, jeśli kupujesz jako firma i potrzebujesz faktury.</div>
          </label>
        </div>

        <!-- Company fields -->
        <template v-if="formData.needs_company">
          <FormInput class="sm:col-span-3" v-model="formData.first_name" label="Imię" placeholder="Adam" />
          <FormInput class="sm:col-span-3" v-model="formData.last_name" label="Nazwisko" placeholder="Nowak" />

          <FormInput class="sm:col-span-6" v-model="formData.company_name" label="Nazwa Firmy"
            placeholder="Adam Nowak sp. z o. o." />
          <FormInput class="sm:col-span-6" v-model="formData.company_tax" label="Numer NIP"
            placeholder="922414248885" />

          <h3 class="sm:col-span-6 text-base font-bold text-neutral-850 mt-2">Adres</h3>

          <FormInput class="sm:col-span-6" v-model="formData.company_address" label="Ulica i numer domu"
            placeholder="Uliczka 17" />

          <FormInput class="sm:col-span-3" v-model="formData.company_city" label="Miasto" placeholder="Wrocław" />
          <FormInput class="sm:col-span-3" v-model="formData.company_postalcode" label="Kod pocztowy"
            placeholder="50-444" />
        </template>

        <!-- Submit Button -->

        <button type="submit" :disabled="saving"
          class="sm:col-span-3 mt-2 max-w-48 max-w-48 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-neutral-950 rounded-full text-sm font-bold transition-colors">
          Zapisz zmiany
        </button>
      </FormSection>

      <!-- Dane Kontaktowe -->
      <FormSection title="Dane Kontaktowe">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm text-neutral-850 mb-2">Adres e-mail</label>
            <div class="flex items-center gap-2">
              <span class="text-sm text-neutral-950">{{ formData.email }}</span>
              <button type="button" class="text-neutral-600 hover:text-neutral-950">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                </svg>
              </button>
            </div>
          </div>

          <div>
            <label class="block text-sm text-neutral-850 mb-2">Numer telefonu</label>
            <div class="flex items-center gap-2">
              <span class="text-sm text-neutral-950">{{ formData.phone }}</span>
              <button type="button" class="text-neutral-600 hover:text-neutral-950">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </FormSection>

      <!-- Dane Uczestnika -->

      <FormSection v-if="formData.profiles && formData.profiles.length > 0" title="Dane Uczestnika">
        <div class="space-y-4">
          <div v-for="(profile, index) in formData.profiles" :key="index"
            class="p-4 border border-neutral-200 rounded-lg">
            <!-- Header with toggle -->
            <div class="flex items-center justify-between mb-4">
              <h4 class="text-sm font-semibold text-neutral-850">Domyślny
                <span
                  class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-primary-100 text-primary-700">{{
                  profile.key }}</span>
                <button type="button" @click="profile._editing = !profile._editing"
                  class="text-neutral-600 hover:text-neutral-950">

                  <svg v-if="!profile._editing" class="w-4 h-4" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z">
                    </path>
                  </svg>

                </button>
              </h4>
            </div>

       

            <!-- View mode -->
            <div v-if="!profile._editing" class="space-y-2">
             
              <p class="text-base text-neutral-600"><strong>Imię:</strong> {{ profile.first_name }}</p>
              <p class="text-base text-neutral-600"><strong>Nazwisko:</strong> {{ profile.last_name }}</p>
              <p class="text-base text-neutral-600 hidden"><strong>Płeć:</strong> {{ profile.gender === 'male' ?
                'mężczyzna' :
                profile.gender === 'female' ? 'kobieta' : profile.gender }}</p>
              <p class="text-base text-neutral-600 hidden"><strong>PESEL:</strong> {{ profile.pesel }}</p>
              <p class="text-base text-neutral-600 hidden"><strong>Narodowość:</strong> {{ profile.nationality }}</p>
              <p class="text-base text-neutral-600 hidden"><strong>Data urodzenia:</strong> {{ profile.date_of_birth }}
              </p>
              <!-- <p class="text-base text-neutral-600"><strong>Ukończony poziom:</strong></p>
              
                <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6 mt-2">
                  <div v-if="profile.level.length === 0" class="col-span-full text-neutral-600">brak</div>
             
                  <PathTag v-for="(level, i) in profile.level" :key="i" :tag="level" />
    
                </div> -->
                
            </div>

            <!-- Edit mode -->
            <div v-else class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <FormInput v-model="profile.first_name" label="Imię" placeholder="Wpisz..." />
              </div>
              <div class="sm:col-span-3">
                <FormInput v-model="profile.last_name" label="Nazwisko" placeholder="Wpisz..." />
              </div>
              <div class="sm:col-span-3 hidden">
                <label class="block text-sm text-neutral-850 mb-2">Płeć</label>
                <select v-model="profile.gender"
                  class="w-full px-3 py-2 border border-neutral-200 rounded-lg text-sm">
                  <option value="male">mężczyzna</option>
                  <option value="female">kobieta</option>
                </select>
              </div>
              <div class="sm:col-span-3 hidden">
                <FormInput v-model="profile.pesel" label="PESEL" placeholder="Wpisz..." />
              </div>
              <div class="sm:col-span-3 hidden">
                <FormInput v-model="profile.nationality" label="Narodowość" placeholder="Wpisz..." />
              </div>
              <div class="sm:col-span-3 hidden">
                <FormInput v-model="profile.date_of_birth" label="Data urodzenia" type="date" placeholder="Wpisz..." />
              </div>


              <button type="submit"
                class="sm:col-span-3 max-w-48 max-w-48 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-neutral-950 rounded-full text-sm font-bold transition-colors">
                Zapisz zmiany </button>

            </div>
          </div>
        </div>
      </FormSection>

     
    </form>
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue';
import FormInput from '../../components/FormInput.vue';
import FormSection from '../../components/FormSection.vue';
import ToggleSwitch from '../../components/ToggleSwitch.vue';
import PathTag from '../../components/PathTag.vue';

import rpAPI from '@shared/service/rpAPI.js';
import Globals from '@shared/model/Globals.js';


export default {
  name: 'ProfilePage',
  components: {
    PageHeader,
    FormInput,
    FormSection,
    ToggleSwitch,
    PathTag,
  },
  data() {
    return {
      saving: false,
      rpAPI,
      formData: {
        first_name: '',
        last_name: '',

        address: '',
        city: '',
        postalcode: '',

        needs_company: false,
        company_name: '',
        company_tax: '',
        company_address: '',
        company_city: '',
        company_postalcode: '',

        email: '',
        phone: '',

        consent1: false,
        consent2: false,
        consent3: false,
      },
    };
  },
  async mounted() {
    this.loadFromUser();
  },
  methods: {
    async loadFromUser() {
      const user = rpAPI.user;

      if (!user) return;

      // załaduj profile, żeby mieć dostęp do dodatkowych pól
      await user.initProfiles();

      console.log('Loaded user profiles:', user.profiles);

      const domain = `@${Globals.EMAIL_DOMAIN}`;
      const isTemporaryEmail = Boolean(user.email && user.phone && user.email === `${user.phone}${domain}`);

      this.formData.first_name = user.first_name || '';
      this.formData.last_name = user.last_name || '';
      this.formData.city = user.city || '';
      this.formData.postalcode = user.postalcode || '';

      this.formData.address = user.address || '';

      this.formData.needs_company = user.needs_company || false;
      this.formData.company_name = user.company_name || '';
      this.formData.company_tax = user.company_tax || '';
      this.formData.company_city = user.company_city || '';
      this.formData.company_postalcode = user.company_postalcode || '';
      this.formData.company_address = user.company_address || '';

      this.formData.phone = user.phone || '';
      this.formData.email = isTemporaryEmail ? '' : user.email || '';

      this.formData.profiles = user.profiles || [];
    },

    async handleSubmit() {
      this.saving = true;
      try {
        const payload = {
          first_name: (this.formData.first_name || '').trim(),
          last_name: (this.formData.last_name || '').trim(),
          city: (this.formData.city || '').trim(),
          postalcode: (this.formData.postalcode || '').trim(),
          address: (this.formData.address || '').trim(),
          needs_company: Boolean(this.formData.needs_company),
        };

        if (this.formData.needs_company) {
          payload.company_name = (this.formData.company_name || '').trim();
          payload.company_tax = (this.formData.company_tax || '').trim();
          payload.company_city = (this.formData.company_city || '').trim();
          payload.company_postalcode = (this.formData.company_postalcode || '').trim();
          payload.company_address = (this.formData.company_address || '').trim();
        }

        await rpAPI.updateCustomer(payload);
        this.$notify?.success?.('Dane zostały zapisane!');
        this.loadFromUser();
      } catch (error) {
        console.log('Profile update failed:', error);
        this.$notify?.error?.(error?.message || 'Nie udało się zapisać danych.');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
